module.exports = __webpack_public_path__ + "static/media/header_scan.bfb74afc.jpg";